/**
 * Copia texto para a área de transferência. A API moderna só existe em
 * contexto seguro (HTTPS ou localhost); fora dele, o caminho antigo — um
 * textarea selecionado e `execCommand('copy')` — ainda funciona. O textarea
 * temporário entra em `container`: dentro de um modal, fica dentro dele.
 */
export async function copyText(text: string, container: HTMLElement = document.body): Promise<boolean> {
  if (window.isSecureContext && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // Permissão negada ou página sem foco: tenta o caminho antigo.
    }
  }

  const area = document.createElement('textarea');
  area.value = text;
  area.setAttribute('readonly', '');
  area.style.position = 'fixed';
  area.style.opacity = '0';
  area.style.pointerEvents = 'none';
  const previous = document.activeElement instanceof HTMLElement ? document.activeElement : null;
  container.append(area);
  area.select();
  let copied = false;
  try {
    copied = document.execCommand('copy');
  } catch {
    copied = false;
  }
  area.remove();
  previous?.focus();
  return copied;
}
